import itLocale from "element-ui/lib/locale/lang/it";
const it = {
  //意大利 Italian
  login: {
    buttoo: {
      add: "新增",
    },
  },
  dialog: {
    buttton: {
      close: "关闭",
    },
    ReportError: {
      //未对应
      next: "Next",
      h1: "Report Errors allows users to communicate with us to solve any data issues and improve data quality.",
      li1: "If you find any data problems or have a question about this data",
      li2: "If you want to contribute company information to improve this data",
      li3: "If you choose not to disclose your own company information that you might consider private",
      li4: "If you have any constructive suggestions for us to improve services",
      h2: "All comments submitted are subject to data verification. Users must complete your own user profile as our representative may contact you for authentication and verification of your company any rights to represent your company.",
    },
  },
  Home: {
    //未对应
    Applications: "Applications",
    SearchCompanies: "Search Companies",
    SearchTrade: "Search Trade",
    SearchRisks: "Search Risks",
    SearchCountries: "Search Countries",
    SearchNews: "Search News",
    SearchLeads: "Search Leads",
    SearchSanctions: "Search Sanctions ",
    RiskScan: "Risk Scan",
    SearchRelationship: "Search Relationship",
    DataServices: "Data Services",
    //未对应

    selectCountry: "Seleziona Paese",
    keWord: "Parola chiave",
    firstWord: "Testo (parole da sinistra)",
    search: "Cerca",
    homeSeachTitle: "Mettiamo a fuoco il business globale",
    homeTitleDetail:
      "CSI, una società di ricerca e IT basata sui dati, è specializzata in credito, rischio e big data. Offre strumenti digitali a investitori e professionisti aziendali globali, sfruttando analisi e algoritmi avanzati per fornire informazioni rapide e visive che facilitano un processo decisionale più intelligente.",
    phoneTitleDetail:
      "Per cercare, visualizzare e ottenere rapidamente informazioni aziendali, puoi anche utilizzare l'app CSI sul tuo telefono.",

    //未对应
    searchCompanyNum:
      "Search 500+ million companies in 200+ countries and territories",
    IndustryAnalysis: "Industry Analysis",
    BusinessAnalytics: "Business Analytics",
    ImportExportData: "Import-Export Data",
    CompanyNews: "Company News",
    Sanctions: "Sanctions",
    BusinessIntelligence: "Business Intelligence",
    CompanyIdentityVerification: "Company Identity Verification",
    KYCSolutions: "KYC Solutions",
    OwnershipPenetration: "Ownership Penetration",
    CompanyFinancialAnalysis: "Company Financial Analysis",
    CreditRatings: "Credit Ratings",
    CreditReports: "Credit Reports",
    ESGRatings: "ESG Ratings",
    VendorScreening: "Vendor Screening ",
    MarketResearch: "Market Research ",
    EnterKeyword: "Enter Keyword",
    Country: "Country",
    Company: "Company",
    Person: "Person",
    Product: "Product",
    EnterPersonName: "Enter Person Name",
    EnterCountryName: "Enter Country Name",
    Entercompanyname: "Inserisci il nome dell'azienda",
    EnterproductName: "Enter product keywords",
    newsHeadTitle:"Uncover the strategic insights behind every company headline",
    sanctionHeadTitle:"Navigate international trade with confidence by screening companies and products against global sanctions",
  },
  Toolbar: {
    Filter: "Filtra",
    Select: "Seleziona",
    Edit: "Modifica",
    Sortby: "Ordina per",
    Collect: "Raccogli",
    Saved: "Salvati",
    Compare: "Confronta",
    Export: "Esporta",
    Download: "Scarica",
    Update: "Aggiorna",
    Reporterror: "Segnala errore",
    Share: "Condividi",

    //未对应
    ascending: "ascending",
    descending: "descending",
    Yourfolder: "Custom folder",
    RiskScanning: "Risk Scanning",
    CreditAssessment: "Credit Assessment",
    DataAnalysis: "Data Analysis",
    NewPortfolio: "New Portfolio",
    Print: "Print",
    Optimize:"Optimize",
  },
  AiZaba: {
    //未对应
    whatareyousearchingfor: "What are you searching for?",
    CreditAnalyst: "Credit Analyst",
    Assesses:
      "Assesses a company'screditworthiness,identifiesfinancial risks,ensuring secure transactionsthrough data analysis andcredit ratings.",
    LegalAdvisor: "Legal Advisor",
    Provides:
      "Provides compliance guidance,reviews contracts,andassesseslegarisks to ensure businessoperations align with lawsand avoid disputes.",
    BizConsultant: "Biz Consultant",
    Optimizes:
      "Optimizes supply chains,identifiesbuyers, andboosts sales by analyzingmarket trends and offeringtailored strategies to improve efficiency",
    EconomicAnalyst: "Economic Analyst",
    Analyzes:
      "Analyzes industry and regional economic trendshelping businesses makeinformed decisions, and staycompetitive.",
  },
  navigationBar: {
    Notifications: "Notifiche", //通知
    MarkasRead: "Segna come letto", //标记已读
    Viewall: "Visualizza tutto", //查看全部
    SilverSubscriber: "Abbonato Silver", //银级用户
    GoldSubscriber: "Abbonato Gold", //金级用户
    SubscriptionExpires: "Data di scadenza dell'abbonamento Gold", //未对应
    AvailableCredits: "Crediti disponibili", //可用积分
    AddCredits: "Aggiungi crediti", //购买积分
    IndivdualAccount: "Account individuale", //个人账号
    GroupAccount: "Account di gruppo", //集团账号
    //未对应
    OrdinaryUsers: "Ordinary users",
    UserAccount: "User Account",
    Roles: "Ruoli", //角色
  },
  ListofResults: {
    Country: "Paese",
    Industry: "Settore",
    CompanyType: "Tipo di azienda",
    CompanySize: "Dimensioni dell'azienda",
    CompanyStatus: "Stato dell'azienda",
    CompanyName: "Nome dell'azienda",
    CoType: "Tipo di azienda",
    RegStatus: "Stato di registrazione",
    StateProvince: "Stato/Provincia",
    CityCounty: "Città/Contea",
    DistrictCity: "Distretto/Città",
    IncDate: "Data di costituzione",
    LegalForm: "Forma giuridica",
    CoID: "ID azienda",
    TaxNo: "Partita IVA",
    ListingInfo: "Informazioni sulla quotazione",
    Phone: "Telefono",
    Website: "Sito web",
    Email: "Email",
    LegalPerson: "Persona giuridica",
    PostCode: "Codice postale",
    ISIC: "ISIC",
    IndustryDescription: "Descrizione del settore",
    NACE: "NACE",
    NAICS: "NAICS",
    CreditRating: "Rating di credito",
    SolvencyIndex: "Indice di solvibilità",
    ProbabilityofDefault: "Probabilità di default",
    NoofEmployees: "Numero di dipendenti",
    Revenue: "Fatturato",
    TotalAsset: "Totale attivo",
    NetProfit: "Utile netto",
    ROA: "ROA",
    ROE: "ROE",
    ShowMore: "Mostra altro",

    //未对应
    SelectCountry: "Select Country",
    ClearAll: "Clear All",
    SelectIndustry: "Select Industry",
    ListedCompany: "Listed Company",
    YearsinBusiness: "Years in Business",
    Sharethisinformation: "Share this information",
    Pleaseaddress: "Please enter one or more email address",
    Example: "Example",
    message: "message",
    pleaseleaveamessage: "please leave a message",
    Include: "",
    thisaddress: "this company name,ID,address",
    CSIwebsite: "CSI website",
    Update: "Update",
    Iftheavailable:
      "If the available online data is insufficient or outdated, you can click the “Update” button to request an instant update for a fresh investigated business credit report from our local networking investigators or credit reporting agencies. The cost for this update is 1 credit per company. The update report typically takes between 24 and 72 hours to be delivered.",
    Abusinesscredit:
      "A business credit report provides detailed information about the subject company’s identification data, registry records, shareholding structure, company history, management description, related companies, actual operations, trade references, financial data and analysis, official public information such as litigation records and sanctions, and credit analysis and assessment.",
    Searchcompanies: "Search more emails on other companies",
    Rowsperpage: "Rows per page",
    Foundover: "Found over",
    results: "results",
    Remove: "Remove",
    Confirm: "Confermare",
  },
  ContentTabs: {
    Background: "Contesto",
    BusinessActivities: "Attività aziendali",
    Performance: "Performance",
    Publications: "Pubblicazioni",
    CreditOpinion: "Opinione creditizia",
    MarketAnalysis: "Analisi di mercato",
    Snapshot: "Sintesi",
    Profile: "Profilo",
    Ownership: "Proprietà",
    RelatedCompanies: "Società collegate",
    Management: "Direzione",
    Operations: "Operazioni",
    Locations: "Sedi",
    Industry: "Settore",
    ImportExport: "Import ed export",
    SupplyChain: "Catena di fornitura",
    FinancialHighlights: "Dati finanziari salienti",
    RatioAnalysis: "Analisi degli indici",
    IndustryNorm: "Norme di settore",
    News: "Notizie",
    Sanctions: "Sanzioni",
    IndustryStatistics: "Statistiche di settore",
    RatingAnalysis: "Analisi del rating",
    CompetitiveAnalysis: "Analisi competitiva",
  },
  Snapshot: {
    CompanyDQIdesc1:
      "The Data Quality Index (DQI) employs algorithms to assess different aspects of data, including completeness, validity, reliability of sources, consistency, timeliness, and bilingual support.",
    CompanyDQIdesc2:
      "The index is designed to assess the quality of data on a scale of 1 to 100, with higher scores indicating superior data quality. Algorithms can analyze data based on predefined rules or criteria, enabling objective and standardized measurements.",
    CompanyDQIdesc3:
      "Our Data Quality Index (DQI) serves as a reliable indicator, allowing users to quantitatively assess data quality. This enables data-driven decision-making and enhances the overall value and utility of the data.",
    CountryDQIdesc1:
      "The Data Quality Index (DQI) assesses the reliability, accuracy, and accessibility of data across countries, reflecting differences in digital infrastructure, governance, and transparency. Developed nations typically rank higher due to strong data systems, open policies, and advanced technology, while developing economies often struggle with gaps in infrastructure, regulation, or data-sharing practices.",
    CountryDQIdesc2:
      "Key factors include government transparency, data protection laws, and technological adoption. A high DQI enables better policymaking and business decisions, while a low score highlights areas needing investment.",
    CompanyDQI: "DQI aziendale", //公司数据质量指数 DQI
    CountryDQI: "DQI nazionale", //国家数据质量指数 DQI
    CompanyTitle: "Data Quality Index (DQI) by Company",
    CountryTitle: "Data Quality Index (DQI) by Country",
    //未对应以上

    Address: "Indirizzo", //地址
    CountyCity: "Contea/Città", //县/市
    ProvinceState: "Provincia/Stato", //省/州
    CountryRegion: "Paese/Regione", //国家/地区
    ZipCode: "CAP", //邮政编码
    Website: "Sito web", //网站
    Email: "Email", //电邮
    Tel: "Tel", //电话
    LastUpdate: "Ultimo aggiornamento", //最近更新
    DataSource: "Fonte dati", //数据来源
    LegalStatus: "Stato giuridico", //法定状况
    CoID: "ID società", //公司ID
    CompanyType: "Tipo di società", //公司类型
    RegistrationDate: "Data di registrazione", //注册日期
    RegistrationStatus: "Stato di registrazione", //注册状态
    Listed: "Quotato", //上市信息
    CurrentOpperations: "Operazioni correnti", //经营状况
    IndustryCode: "Codice di settore", //行业代码
    BusinessActivities: "Attività commerciali", //主营业务
    NoofEmployees: "Numero di dipendenti", //员工数量
    NoofShareholders: "Numero di azionisti", //股东数量
    Management: "Direzione", //管理状况
    Performance: "Performance", //业绩表现
    Revenue: "Fatturato", //收入
    Assets: "Attività", //资产
    ProfitLoss: "Utile/Perdita", //利润
    Growth: "Crescita", //公司增长
    Competitiveness: "Competitività", //竞争力
    CreditOpinion: "Opinione creditizia", //信用状况
    CreditRating: "Rating creditizio", //信用评级
    CreditScore: "Punteggio creditizio", //信用评分
    ESGRating: "Rating ESG", //ESG 评级
    Solvency: "Solvibilità", //偿还能力
    Sanctions: "Sanzioni", //全球制裁
    CoName: "Nome dell'azienda",
    //未对应
    RegName: "Reg. Name",
  },
  Profile: {
    CompareCompanies: "Compare Companies", //未对应
    AddaCompany: "Add a Company", //未对应
    CompanyProfile: "Profilo aziendale", //基本资料
    CompanyName: "Nome dell'azienda", //公司名称
    NativeName: "Nome nativo", //当地名称
    CompanyID: "ID azienda", //公司 ID
    VATNumber: "Partita IVA", //VAT号
    StockCode: "Codice azionario", //股票代码
    Listed: "Quotato", //上市日期
    RegistrationDate: "Data di registrazione", //注册日期
    LegalForm: "Forma giuridica", //公司性质
    CompanyType: "Tipo di società", //公司类型
    LegalStatus: "Stato giuridico", //注册状态
    Jurisdiction: "Giurisdizione", //司法管辖区
    RegisteredAddress: "Sede legale", //注册地址
    ProvinceState: "Provincia/Stato", //省/州
    CountryRegion: "Paese/Regione", //国家/地区
    ZipCode: "CAP", //邮政编码
    OperatingAddress: "Sede operativa", //经营地址
    LastUpdate: "Ultimo aggiornamento", //最近更新
    DataSource: "Fonte dati", //数据来源
    History: "Cronologia", //历史记录

    //未对应
    RegisteredCapital: "Registered Capital",
    PaidinCapital: "Paid-in Capital",

    CountyCity: "Contea/Città",
  },
  Ownership: {
    UltimateBeneficiary: "Beneficiario finale", //最终受益人
    InvolvingIndividuals: "Coinvolge persone fisiche", //涉及自然人股东
    InvolvingEnterprises: "Coinvolge imprese", //涉及法人股东
    ShareholderLevel: "Livello di azionista", //股东层级x
    Name: "Nome", //名称
    Country: "Paese", //国家/地区
    Location: "Luogo", //地点
    Type: "Tipo", //类型
    Shares: "Azioni", //股份
    Relation: "Rapporto", //关系

    //未对应
    Individuals: "Individuals", //关系
    PartiesInvolved: "Parties Involved",
    RelatedCompany: "Related Company",
    CompanyShareholders: "Company Shareholders",
    NGOShareholders: "NGO Shareholders",
    NaturalPersonShareholder: "Natural Person Shareholder",
    SubjectInvestments: "Subject's Investments",
  },
  RelatedCompanies: {
    Total: "Totale", //相关公司总计
    Entities: "Entità", //法人实体
    Countries: "Paesi", //国家/地区
    Branches: "Filiali", //分支机构
    RelatedComp: "Società collegate", //关联公司
    Name: "Nome", //名称
    Country: "Paese", //国家/地区
    Location: "Sede", //地点
    Type: "Tipo", //类型
    Relation: "Rapporto", //关系

    //未对应
    BranchOffices: "Branch Offices",
    Individuals: "Individuals",
  },
  Management: {
    Management: "Direzione", //管理层
    ContactInfo: "Informazioni di contatto", //联系人信息
    Countries: "Paesi", //国家/地区
    Name: "Nome", //名称
    Position: "Posizione", //职位
    Department: "Dipartimento", //部门
    Country: "Paese", //国家/地区
    ShareholderNot: "Azionista o meno", //是否股东
    Relation: "Relazioni", //关系
    Verification: "Verifica", //已验证
    Searchmoreemails: "Cerca altre email", //搜索更多电邮
    Roles: "Ruoli", //角色
    EducationLevel: "Livello di istruzione", //教育程度
    Phone: "Telefono", //电话
    Email: "Email", //电邮
    Verified: "Verificato", //已验证
    Searchmore: "Cerca altre email su altre aziende", //搜索更多其他公司的电邮
    //未对应
    Pleaseentername: "Please enter name",
    PleaseenterWebsite: "Please enter Website",
    UserSelfVerification: "User Self Verification",
    Userverified: "User verified",
    Source: "Origine",
  },
  Operations: {
    Operations: "Operations",
    LineofBusiness: "Settore di attività", //业务范围
    BusinessTerritories: "Aree commerciali", //业务区域
    ImportExport: "Importazione ed esportazione", //进出口信息
    Viewtradeinfo: "Visualizza ulteriori informazioni commerciali", //查看更多贸易信息
    ProductsServices: "Prodotti/Servizi", //产品/服务
    Products: "Prodotti", //产品
    ProductImage: "Immagine del prodotto", //产品图片
    ProductName: "Nome del prodotto", //产品名称
    ProductDescription: "Descrizione del prodotto", //产品描述
    Details: "Dettagli", //详情
    Addproductinformation: "Aggiungi informazioni sul prodotto", //添加产品信息
    //未对应
    Showcaseyourcompany:
      "If you’d like to showcase your company’s products or services to the public, you can add your product and service information here. This is a great way to promote your business. Once we’ve reviewed your submission, your data will be published.",
  },
  Locations: {
    Locations: "Locations",
    CoName: "Nome dell'azienda", //业务范围
    Relationship: "Rapporto", //关系
    Type: "Tipo", //类型
    Country: "Paese", //国家/地区
    Location: "Sede", //地点
    Address: "Indirizzo", //地址
    Edit: "Modifica", //编辑
    CompanyLocatiionsMap: "Sedi dell'azienda sulla mappa", //地图中的公司位置
    Selectaddresstype: "Seleziona il tipo di indirizzo", //选择地址类型
    Subjectcompany: "Società interessata", //目标公司
    Subsidiary: "Filiale", //子公司
    RegisteredAddress: "Sede legale", //注册地址
    OperationAddress: "Indirizzo operativo", //运营地址
    All: "Tutti", //全部
    //未对应
    Showlocation: "Show location ",
  },
  Industry: {
    IndustryTitle: "Titolo del settore", //IndustryTitle
    IndustryDescription: "Descrizione del settore", //IndustryDescription
    ISIC: "ISIC", //ISIC
    ISICDescription: "Descrizione ISIC", //ISICDescription
    NACE: "NACE", //NACEDescription
    NACEDescription: "Descrizione NACE", //NACEDescription
    NAICS: "NAICS", //NAICS
    NAICSDescription: "Descrizione NAICS", //NAICSDescription
    CSIC: "CSIC", //CSIC,
    CSICDescription: "Descrizione CSIC", //CSICDescription
    AAAIC: "AAAIC", //AAAIC
    AAAICDescription: "Descrizione AAAIC", //AAAICDescription
    GICS: "GICS", //GICS
    GICSDescriptio: "Descrizione GICS", //GICS 描述
  },
  ImportExport: {
    TotalImportAmount: "Importo totale delle importazioni", //进口总额
    TopImportCountry: "Paese di importazione principale", //最大进口国家/地区
    TopImportProduct: "Prodotto di importazione principale", //最大进口产品
    TotalExport: "Esportazione totale", //出口总额
    TopExportCountry: "Paese di esportazione principale", //最大出口国家/地区
    TopExportProduct: "Prodotto di esportazione principale", //最大出口产品
    TradeVolume: "Volume commerciale", //贸易额
    ImportShipments: "Spedizioni di importazione", //进口量
    ExportShipments: "Spedizioni di esportazione", //出口量
    ImportCountries: "Paesi di importazione", //进口国家/地区
    ExportCountries: "Paesi di esportazione", //出口国家/地区
    ImportVolume: "Volume di importazione", //进口量
    ExportVolume: "Volume di esportazione", //出口量
    Suppliers: "Principali fornitori", //主要供应商
    Shipments: "Per numero di spedizioni", //按出货量
    Buyers: "Principali acquirenti", //主要买家
    ImportQuantity: "Quantità di importazione", //进口数量
    IncreaseDecreasexRate: "Tasso di aumento/diminuzione", //增/减率
    ExportQuantity: "Quantità di esportazione", //出口数量
    ImportsExportsRecords: "Registri di importazioni ed esportazioni", //进出口记录
    Date: "Data", //日期
    Product: "Prodotto", //产品
    HSCode: "Codice SA", //HS 编码
    BuyerName: "Nome dell'acquirente", //买家名称
    Destination: "Destinazione", //目的地
    SupplierName: "Nome del fornitore", //供应商名称
    Origin: "Origine", //原产地
    Amount: "Importo (USD)", //金额
    Details: "Dettagli", //详情
    Selectdate: "Seleziona la data",

    //未对应
    Imports: "Imports",
    Exports: "Exports",
    Shipments2: "Shipments",
    value2: "value",
    value: "By Number of value",
    viewmoretradeinfo: "view more trade info",
    SearchHSCode: "Search HS Code",
  },
  SupplyChain: {
    //未对应
    Illustratesthesubjectcompany:
      "This chart illustrates the subject company’s “buy from” and “sell to” relationships. The larger the volume, the thicker the tube.",
  },
  ShippingOrderDetails: {
    Date: "Data",
    MasterBillofLading: "Polizza di carico principale",
    Source: "Origine",
    BillNo: "N. fattura",
    ImporterBuyer: "Importatore / Acquirente",
    ExporterSeller: "Esportatore / Venditore",
    Name: "Nome",
    Address: "Indirizzo",
    Country: "Paese",
    Contact: "Contatto",
    Email: "Email",
    CargoInfo: "Informazioni sul carico",
    HSCode: "Codice SA",
    Quantity: "Quantità",
    WeightUnit: "Unità di peso",
    ProductDescription: "Descrizione del prodotto",
    Amount: "Importo (USD)",
    QuantityUnit: "Unità di quantità",
    Weight: "Peso",
    HSDescription: "Descrizione SA",
    Incoterms: "Incoterms",
    ShippingInfo: "Informazioni sulla spedizione",
    Vessel: "Nave",
    Consignee: "Destinatario",
    MeansofTransport: "Mezzo di trasporto",
    CountryofOrigin: "Paese di origine",
    Voyage: "Viaggio",
    Notifier: "Notificatore",
    CountryofDestnation: "Paese di destinazione",
    AddressofOrigin: "Indirizzo di origine",
    Shipper: "Mittente",
    AddressofDestnation: "Indirizzo di destinazione",
    Container: "Container",
    ContainerID: "ID container",
    ContainerType: "Tipo di container",
    ContainerDescDode: "Descrizione container",
    ContainerSize: "Dimensioni container",
    //未对应
    ImportExport: "Importador / Exportador", 
    Imports: "Imports",
    Exports: "Exports",
  },
  FinancialHighlight: {
    Revenue: "Ricavi", //收入
    Profit: "Utili", //利润
    Growth: "Crescita", //增长
    Liquidity: "Stato del flusso di cassa", //现金流状况
    FinancialStructure: "Struttura finanziaria", //融资结构
    CreditOpinion: "Opinione creditizia", //信用评估
    RiskIndicator: "Indicatore di rischio", //风险指标
    Solvencyindex: "Indice di solvibilità", //偿还指数
    Year: "Anno", //年份
    Change: "Variazione", //变化
    NetProfit: "Utile netto",
    TotalAssets: "Totale attivo",
    Equity: "Patrimonio netto",
    GrossMargin: "Margine lordo",
    ProfitMargin: "Margine di profitto",
    ReturnonEquity: "Rendimento del capitale proprio",
    CurrentRatio: "Indice di liquidità",
    DebtRatio: "Indice di indebitamento",
    FinancialHighlights: "Dati finanziari delle società collegate", //关联公司财务数据
    FinancialHighlightsTitle:
      "Dati finanziari salienti delle società collegate", //关联公司财务摘要
    CompanyName: "Nome della società", //公司名称
    CompanyID: "ID della società", //公司ID
    Country: "Paese", //国家/地区
    CompanyStatus: "Stato della società", //公司状态
    Relations: "Relazioni", //关系
    Cancel: "Annulla", //取消
    Select: "Seleziona",
    RatioAnalysis: "Analisi degli indici delle società collegate", //关联公司比率分析
    //未对应
    Financialperformancedata:
      "Financial performance data is collected from various governmental sources and local credit reporting agencies. Additionally, market and industry research is used to calculate and model the data. For more detailed information about the actual operations and performance analysis, please contact our service team to request a company due diligence report.",
    Whenthesubjectsdata:
      "When the subject’s data is insufficient, or you’re interested in gaining more insights into your customer, this platform offers a comprehensive view of all entities related to the subject. This includes the subject’s company’s shareholders, related companies, and more.",
    Byprovidingyou:
      "By providing you with a broader perspective, this platform empowers you to make more informed evaluations and gain a deeper understanding of your subject.",
    PleaseSelectTheYeartoDisplay: "Please Select The Year to Display",
    SelectUptoThreeYears: "Select Up to Three Years",
  },
  RatioAnalysis: {
    ProfitabilityRatios: "Indici di redditività",
    Year: "Anno",
    Change: "Variazione",
    Returnonequity: "Rendimento del capitale proprio",
    Returnonassets: "Rendimento delle attività",
    Profitmargin: "Margine di profitto",
    Grossmargin: "Margine lordo",
    OperatingRatios: "Indici operativi",
    Assetsturnover: "Rotazione delle attività",
    Stockturnover: "Rotazione delle scorte",
    Salesperiod: "Periodo di vendita",
    Collectionperiod: "Periodo di incasso",
    Creditperiod: "Periodo di credito",
    StructuralRatios: "Indici di struttura",
    Currentratio: "Indice di liquidità",
    Quickratio: "indice di liquidità immediata",
    Shareholdersliquidityratio: "Indice di liquidità degli azionisti",
    Solvencyratio: "Indice di solvibilità",
    Debtratio: "Indice di indebitamento",
    ProductivityRatios: "Indici di produttività",
    Profitperemployee: "Utile per dipendente",
    Operatingrevenueperemployee: "Ricavi operativi per dipendente",
    Shareholdersfundsperemployee: "Patrimonio netto per dipendente",
    Totalassetsperemployee: "Totale attivo per dipendente",
    GrowthRatios: "Indici di crescita",
    Salesgrowthrate: "Tasso di crescita delle vendite",
    Netprofitgrowthrate: "Tasso di crescita dell'utile netto",
    Totalassetsgrowthrate: "Tasso di crescita del totale attivo",
    FinancialHighlights: "Dati finanziari delle società collegate", //关联公司财务数据
    RatioAnalysis: "Analisi degli indici delle società collegate", //关联公司比率分析
    CompanyName: "Nome della società",
    CompanyID: "ID della società",
    Country: "Paese",
    CompanyStatus: "Stato della società",
    Relations: "Relazioni",
  },
  IndustryNorms: {
    IndustryStatistics: "Statistiche di settore",
    ofcompaniesintheIndustry: "Numero di aziende nel settore",
    oflistedCompaniesintheIndustry: "Numero di aziende quotate nel settore",
    oflargecompaniesintheIndustry: "Numero di grandi aziende nel settore",
    ofSMEsintheIndustry: "Numero di PMI nel settore",
    ofcompaniesinsample: "Numero di aziende nel campione",
    ofcompaniesinloss: "Numero di aziende in perdita",
    Observations: "Osservazioni",
    AverageValue: "Valore medio",
    MedianValue: "Valore mediano",
    MaximumValue10: "Valore massimo 10%",
    MinimumValue10: "Valore minimo 10%",
    SubjectCompany: "Azienda in questione",
    YearsinBusiness: "Anni di attività",
    TotalAssets: "Totale attivo",
    TotalEquity: "Patrimonio netto totale",
    Revenue: "Ricavi",
    NetEarning: "Utile netto",
    Returnonassets: "Rendimento delle attività",
    Performance: "Performance",
    ProfitabilityRatios: "Indici di redditività",
    Returnonequity: "Rendimento del capitale proprio",
    Returnonassets: "Rendimento delle attività",
    Grossmargin: "Margine lordo",
    OperatingRatios: "Indici operativi",
    Stockturnover: "Rotazione delle scorte",
    Accountsreceivableturnover: "Rotazione dei crediti commerciali",
    Assetsturnover: "Rotazione delle attività",
    Totalassetturnover: "Rotazione delle attività totali",
    StructuralRatios: "Indici di struttura",
    Currentratio: "Indice di liquidità",
    Quickratio: "indice di liquidità immediata",
    Shareholdersliquidityratio: "Indice di liquidità degli azionisti",
    GrowthRatios: "Rapporti di crescita",
    Salesgrowthrate: "Tasso di crescita delle vendite",
    Netprofitgrowthrate: "Tasso di crescita dell'utile netto",
    Totalassetsgrowthrate: "Tasso di crescita del totale attivo",
  },
  Lawsuits: {
    //未对应
    Lawsutis: "Lawsutis",
    Date: "Date",
    CaseCategory: "Case Category",
    Title: "Title",
    CaseNo: "Case No.",
    CauseofAction: "Cause of Action",
  },
  News: {
    Date: "Data", //日期
    Title: "Titolo", //标题
    Source: "Impatto", //来源
    Impact: "Impatto", //影响
    Searchcompanies: "Cerca altre notizie su altre aziende", //国家/地区
    //未对应
    SearchforTitle: "Search for Title",
    CompanyName:"Company Name",
    Industry: "Industry",
    Subjects:"Subjects",
    NewsTypes:"News Types",
    ByDate:"By Date",
    SelectCompanyName:"Select Company Name",
    SelectIndustry: "Select Industry",
    SelectSubjects:"Select Subjects",
    SelectNewsType:"Select News Type",
    Negative:"Negative",
    Positive:"Positive",
  },
  Sanctions: {
    Potentialcompliance: "Sono stati rilevati potenziali rischi di conformità", //检测到潜在合规风险
    SeachbuttonNo: "Non è stato rilevato nulla di dannoso per questa azienda", //未检测到任何与该公司相关的不良记录
    SeachbuttonYes:
      'Per cercare altri record di sanzioni, fare clic sul pulsante "Cerca sanzioni".', //要搜索更多制裁记录，请点击“搜索制裁”按钮。
    SearchSanctions: "Cerca sanzioni", //搜索制裁
    ViewDetails: "Visualizza dettagli", //查看详情
    Sanctions: "Sanzioni", //制裁
    Potentialcompliancerisks: "Potenziali rischi di conformità", //潜在合规风险
    IDInfo: "Informazioni ID", //ID 信息
    IDType: "Tipo ID", //ID 类型
    IDDescription: "Descrizione ID", //ID 描述
    SanctionList: "Elenco sanzioni", //制裁名单
    SanctionListInvolved: "Elenco sanzioni interessato", //涉及的制裁名单
    StartDate: "Data di inizio", //生效日期
    EndDate: "Data di fine", //结束日期
    SourceList: "Elenco fonti", //来源名单
    SourceName: "Nome fonte", //来源名称
    ProfileNotes: "Note profilo", //主体资料
    Link: "Link", //链接
    Name: "Nome", //名称
    //未对应
    AssociationList: "Association List",
    AssociationID: "Association ID",
    AssociationType: "Association Type",
  },
  CreditOpinion: {
    CreditAssessment: "Valutazione del merito creditizio",
    CreditAssessmentfromtheRelatedCompanies:
      "Valutazione del merito creditizio delle società collegate",
    Year: "Anno",
    CreditRating: "Rating creditizio",
    LocalCreditScore: "Punteggio creditizio locale",
    ProbabilityofDefault: "Probabilità di default",
    SolvencyIndex: "Indice di solvibilità",
    CreditLine: "Linea di credito",
    RiskIndicator: "Indicatore di rischio",
    RelatedCreditAssessment: "Valutazione del merito creditizio correlato",
    CompanyName: "Nome della società",
    CompanyID: "ID della società",
    Country: "Paese",
    CompanyStatus: "Stato della società",
    Relations: "Relazioni",
    Cancel: "Annulla", //取消
    Select: "Seleziona",
    //未对应
    LocalCreditScore: "Local Credit Score",
    SolvencyIndex: "Solvency Index",
    ProbabilityofDefault: "Probability of Default",
    RiskIndicator: "Risk Indicator",
    CreditAssessmentMessage1:
      "When the subject’s data is insufficient, or you’re interested in gaining more insights into your customer, this platform offers a comprehensive view of all entities related to the subject. This includes the subject’s company’s shareholders, related companies, and more.",
    CreditAssessmentMessage2:
      "By providing you with a broader perspective, this platform empowers you to make more informed evaluations and gain a deeper understanding of your subject.",
    LocalCreditRating: "Local Credit Rating",
    LocalCreditRatingDetail:
      "Driven by the power of big data, 3ARating is a quantitative rating system for private companies. It is a collaborative effort between 3ACredit and Creditreform Rating. The rating model is built based on a comprehensive evaluation of various key factors, including non-financial factors, financial factors, negative records, and industry-specific considerations. The rating model exhibits an impressive Gini coefficient, indicating its robustness and reliability. 3ARating spans a range of ratings, from the highest rating, 3A1, to the lowest rating class, 3A19.",
    CreditScore: "Credit Score",
    CreditScoreDetail:
      "Credit scores are calculated on a scale from 1 to 100, based on the credit rating obtained from local authorities. A higher score indicates better creditworthiness.",
    PossibilityofDefault: "Possibility of Default (PD)",
    PossibilityofDefaultDetail:
      "The Possibility of Default (PD) is a useful tool for risk assessment, focusing on short-term liquidity evaluation.",
    SolvencyIndexSI: "Solvency Index (SI)",
    SolvencyIndexSIDetail:
      "The Solvency Index (SI) is a highly effective and reliable early warning indicator that allows for a rapid assessment of the solvency of business partners. A higher SI value indicates a higher risk of default by a client. The SI ranges from 100, which is considered an excellent rating, to 600, where highly negative characteristics are present.",
    ExternalRating: "External Rating",
    DefaultProbability: "Default Probability (Pd1Year)",
    Rating: "3ARating (>=,<=)",
    PleaseSelectTheYeartoDisplay: "Please Select The Year to Display",
    SelectUptoThreeYears: "Select Up to Three Years",
    HighRisk: "High Risk",
    Medium: "Medium",
    Moderate: "Moderate",
    Average: "Average",
    LowerThanAvg: "Lower Than Avg",
    LowRisk: "Low Risk",
    CreditOpinion: "Credit Opinion",
  },
  IndustryStatistics: {
    SubjectCompany: "Azienda",
    Country: "Paese",
    Compare: "Confronta",
    Industry: "Settore",
    CompanyType: "Tipo di azienda",
    CompanySize: "Dimensioni dell'azienda",
    CompanyStatus: "Stato dell'azienda",
    YearsinBusiness: "Anni di attività",
    CompanyRating: "Valutazione dell'azienda",
    Liquidity: "Stato del flusso di cassa",

    //未对应
    NoofcoinIndustry: "No. of co. in Industry",
    IndustryRating: "Industry Rating",
    Profitability: "Profitability",
    Repaying: "Repaying",
    SearchCountry: "Search Country",

    Growth: "Crescita",
    FinancialStructurt: "Struttura finanziaria",
  },
  RatingAnalysis: {
    IndustyAnalysis: "Analisi di settore",
    GeographicAnalysis: "Analisi geografica",
    CompanyTypeAnalysis: "Analisi del tipo di azienda",
    BiusinessScaleAnalysis: "Analisi della scala di business",
    HistoryAnalysis: "Analisi storica",
    NormalDistribution: "Distribuzione normale",
    SubjectCompany: "Azienda oggetto di studio",
    Probabilityofthesubjectratinginitsindustry:
      "Probabilità del rating dell'azienda oggetto di studio nel suo settore",
    Maximum: "Massimo 10%",
    Mean: "Media",
    Average: "Media",
    Minimum: "Minimo 10%",
    RatingDistribution: "Distribuzione del rating",
    Revenue: "Fatturato",
    Earning: "Utile",
    TotalAssets: "Totale attivo",
    Subjectratinginitsindustrybyfinancialindicators:
      "Rating dell'azienda oggetto di studio nel suo settore in base agli indicatori finanziari",
    Best: "Migliore",
    Worst: "Peggiore",
    Rankingofsubject:
      "Classificazione del rating dell'azienda oggetto di studio nel settore",
    Industy: "Settore",
    Percentilerank:
      "Posizione percentile: % di aziende che hanno ottenuto un punteggio pari o inferiore al rating dell'azienda oggetto di studio",
    Historicaldevelopmentofsubject:
      "Sviluppo storico del rating dell'azienda oggetto di studio nel suo settore",
    IndustryAverage: "Media del settore",
    SubjectRatingChanges:
      "Variazioni del rating dell'azienda oggetto di studio",
    CompanySize: "Dimensioni dell'azienda",
    YearsinBusiness: "Anni di attività",
    //未对应
    CreditScore: "Credit Score",
    NOofCompanies: "NO. of Companies",
    ofCompanies: "% of Companies",
    CreditRating: "Credit Rating",
    SubjectsIndustryConcentrationAnalysis:
      "Subject's Industry Concentration Analysis",
    GeographicdistributionofSubjectsratingintsindustry:
      "Geographic distribution of Subject's rating in its industry",
    GeographicdistributioninSubjectindustry:
      "Geographic distribution in Subject's industry：",
    RatingDistributioninSubjectsLocation:
      "Rating Distribution in Subject's Location",
    Ratinganalysisofcompanies:
      "Rating analysis of companies in the same industry with different years in business",
    Subjectsratinghistory:
      "Subject's rating history comparing with its peers with the same history",
    Ratingrankingofcompanieswithsamehistory:
      "Rating ranking of companies with same history",
    Ratingstatistics:
      "Rating statistics of companies with the same years in business",
    Subjectratingcomparing:
      "Subject rating comparing with its peer companies with the",
    Subjectratinginitsgroup: "Subject rating in its group:",
    Analysisbasedonnature:
      "Analysis based on nature of companies in subject's industry",
    Subjectratingpositioninitscompanytype:
      "Subject rating position in its company type:",
    Ratingstatisticsofcompanies:
      "Rating statistics of companies in the same industry",
    Ratinganalysisofcompanies:
      "Rating analysis of companies of different sizes in the same industry",
    Probabilityofsubjectrating:
      "Probability of subject rating in its industry within its size",
    Subjectratingcomparingwithindustry:
      "Subject rating comparing with its peers in its industry:",
    RatingRankingofthecompanies:
      "Rating Ranking of the companies in the same size in the same industry",
    Ratingstatisticsofcompanies:
      "Rating statistics of companies in the same size and same industry",
    Rank: "Rank",
    Rating: "Rating",
  },
  CompetitiveAnalysis: {
    MarketPosition: "Posizione di mercato",
    Revenus: "Ricavi",
    NetEarnings: "Utili netti",
    NetAssets: "Attività nette",
    TotalAssets: "Totale attivo",
    Employees: "Dipendenti",
    Mean: "Media",
    Average: "Media",
    Maximum: "Massima (10%)",
    Worst: "Peggiore (10%)",
    Subjectcompany: "Azienda oggetto di analisi",
    PerformanceComparison: "Confronto delle performance",
    ProfitabilityRatios: "Indici di redditività",
    Grossmargin: "Margine lordo",
    Returnonassets: "Rendimento delle attività",
    Returnonequity: "Rendimento del capitale proprio",
    OperatingRatios: "Indici operativi",
    Stockturnover: "Rotazione delle scorte",
    Assetsturnover: "Rotazione delle attività",
    Collectionperiod: "Periodo di incasso",
    GrowthRatios: "Indici di crescita",
    Totalassetsgrowthrate: "Tasso di crescita del totale attivo",
    Salesgrowthrate: "Tasso di crescita delle vendite",
    Netprofitgrowthrate: "Tasso di crescita dell'utile netto",
    StructuralRatios: "Indici di struttura",
    Debtratio: "Indice di indebitamento",
    Quickratio: "indice di liquidità immediata",
    Currentratio: "Indice di liquidità",
  },
  AccountCenterMenu: {
    SearchinSettings: "Cerca in Impostazioni", //在“设置”中搜索
    Account: "Account", //账户
    MyAccount: "Il mio account", //我的账户
    ContactInfo: "Informazioni di contatto", //联系信息
    AccountSecurity: "Sicurezza dell'account", //账户安全
    OrganizationalManagement: "Gestione organizzativa", //组织管理
    UserGroup: "Gruppo utenti", //用户组
    User: "Utente", //用户
    Role: "Ruolo", //角色
    MyDatabase: "Il mio database", //我的数据库
    MyUsage: "Il mio utilizzo", //我的使用情况
    CompaniesViewed: "Aziende visualizzate", //查看过的公司
    ReportsDownloaded: "Report scaricati", //下载的报告
    ReportUpdatesOrdered: "Aggiornamenti report ordinati", //订购的报告更新
    BillingandPayment: "Fatturazione e pagamento", //账单和付款
    BillRecords: "Registri fatture", //账单记录
    PaymentRecords: "Registri pagamenti", //付款记录
    CreditDeductions: "Detrazioni credito", //信用扣款
    InvoicesDownloaded: "Fatture scaricate", //下载的发票
    UserSettings: "Impostazioni utente", //用户设置
    Messages: "Messaggi", //消息
    Notifications: "Notifiche", //通知
    HelpCenter: "Centro assistenza", //帮助中心
    FAQ: "FAQ", //常见问题
    Privacy: "Privacy", //隐私
    Terms: "Termini", //条款
    ReportIssues: "Segnala problemi", //报告问题
    UserGuide: "Guida utente", //用户指南
    AboutCSI: "Informazioni su CSI", //关于CSI
  },
  MyAccount: {
    Logintime: "Ora di accesso", //登录时间
    SignOut: "Esci", //退出
    DeleteAccount: "Elimina account", //删除账户
    AccountID: "ID account", //账户ID
    Enteranewaddress: "Inserisci un nuovo indirizzo email", //输入新的电邮
    EnterVerificationCode: "Inserisci codice di verifica", //输入验证码
    SendverificationCode: "Invia codice di verifica", //发送验证码
    Password: "Password", //密码
    Originalpassword: "Password originale", //原始密码
    Newpassword: "Nuova password", //新密码
    Confirmnewpassword: "Conferma nuova password", //确认新密码
    AccountOwnership: "Titolare dell'account", //账户所有权
    IndividualAccount: "Account individuale", //个人账户
    GroupAccount: "Account di gruppo", //集团账户
    Organizationname: "Nome dell'organizzazione", //机构名称
    CountryRegion: "Paese/Regione", //国家/地区
    Address: "Indirizzo", //地址
    City: "Città", //城市
    ZipCode: "CAP", //邮政编码
    FirstName: "Nome", //名字
    LastName: "Cognome", //姓氏
    PhoneNumber: "Numero di telefono", //电话号码
    Email: "Email", //更改
    Change: "Modifica", //更改
    Save: "Salva", //保存
    Cancel: "Annulla", //取消
    LastLogin: "Ultimo accesso", //Last Login
    RecentLogin: "Accessi recenti", //登录尝试次数
    AverageLoginTime: "Tempo medio di accesso", //平均登录时间
    TotalLoginAttempts: "Tentativi di accesso totali", //登录尝试次数
    //未对应
    Registrationtime: "Registration time",
    Role: "Ruolo",
    Administrator: "Administrator",
    Enterpriseusers: "Enterprise users",
    EditImage: "Edit Image",
    DeleteImage: "Delete Image",
  },
  ContactInfo: {
    ContactInfo: "Informazioni di contatto",
    FirstName: "Nome",
    LastName: "Cognome",
    PhoneNumber: "Numero di telefono",
    Email: "Email",
    CountryRegion: "Paese/Regione",
    AddressLine: "Indirizzo",
    City: "Città",
    ZipCode: "CAP",
    Alternativecontactperson: "Persona di contatto alternativa",
    Setascontactperson: "Imposta come persona di contatto",
    Edit: "Modifica",
  },
  AccountSecurity: {
    Setupmysecurityquestions: "Imposta le mie domande di sicurezza",
    Pleasechooseaquestion: "Scegli una domanda",
    Pleaseentertheanswertothequestion: "Inserisci la risposta alla domanda",
    SessionTimeoutAutomaticLogoutSettings:
      "Timeout sessione: Impostazioni di disconnessione automatica",
    Thesystemwillautomatically:
      "Il sistema ti disconnetterà automaticamente dopo un periodo di inattività. Il timeout predefinito è impostato su 5 minuti, ma puoi modificarlo in base alle tue esigenze.",
  },
  MyDatabase: {
    TotalNumberofCompaniesSearched: "Numero totale di aziende ricercate",
    TotalNumberofCompaniesCollected: "Numero totale di aziende raccolte",
    TotalNumberofUpdateReportsOrdered:
      "Numero totale di report di aggiornamento ordinati",
    Date: "Data",
    UserName: "Nome utente",
    CompanyName: "Nome azienda",
    Status: "Stato",
    UsageType: "Tipo di utilizzo",
    Entercompanyname: "Inserisci il nome dell'azienda",
    Download: "Scarica",
  },
  OrganizationalManagement: {
    GroupName: "Nome del gruppo",
    ParentGroupName: "Nome del gruppo padre",
    Organization: "Organizzazione",
    GroupID: "ID gruppo",
    GroupStatus: "Stato del gruppo",
    Operation: "Operazione",
    NewlyBuilt: "Nuova creazione",
    UserAccount: "Account utente",
    Role: "Ruolo",
    AccountStatus: "Stato dell'account",
    RoleName: "Nome del ruolo",
    Position: "Posizione",
    RoleStatus: "Stato del ruolo",
    Valid: "Valido",
    Invalid: "Non valido",
    PermissionSettings: "Impostazioni autorizzazioni",
    Search: "Cerca",
    Cancel: "Annulla",
    Confirm: "Confermare",
    //未对应
    NewGroup: "New Group",
    EnterGroupName: "Enter Group Name",
    NumberofGroups: "Number of Groups",
    Groups: "Groups",
    Roles: "Ruoli",
    NewRoles: "New Roles",
    EnterNewRole: "Enter New Role",
    Users: "Users",
    EnterUserName: "Enter User Name",
  },
  BillingandPayment: {
    TotalNumberofOrders: "Numero totale di ordini",
    TotalPaymentAmount: "Importo totale del pagamento",
    TotalUsedCredits: "Totale crediti utilizzati",
    Date: "Data",
    UserAccount: "Account utente",
    CompanyName: "Nome dell'azienda",
    OrderNo: "Numero d'ordine",
    OrderType: "Tipo di ordine",
    OrderStatus: "Stato dell'ordine",
    Download: "Scarica",
    PaymentAmount: "Importo del pagamento",
    Contactus: "Contattaci",
    DownloadInvoice: "Scarica fattura",
    CreditUsage: "Utilizzo del credito",
    ReportOrderStatus: "Report sullo stato dell'ordine",
    CompanyID: "ID azienda",
    CountryRegion: "Paese/Regione",
    AddressLine: "Riga indirizzo",
    City: "Città",
    ZipCode: "CAP",
    FirstName: "Nome",
    LastName: "Cognome",
    PhoneNumber: "Numero di telefono",
    Email: "Email",
    BankAccountHolderName: "Nome del titolare del conto bancario",
    BeneficiaryBankName: "Nome della banca beneficiaria",
    SWIFTCODE: "CODICE SWIFT",
    AccountNumber: "Numero di conto",
    BeneficiaryBankAddress: "Indirizzo della banca beneficiaria",
    ABA: "ABA (Codice di avviamento bancario)",
    IBANnumber: "Codice IBAN",
    //未对应
    StartingMonth: "Starting Month",
    EndMonth: "End Month",
    InvoiceInfo:"Invoice Info",
  },
  UserSettings: {
    LanguageandLocation: "Lingua e posizione",
    Language: "Lingua",
    Selectyourpreferedlanguage: "Seleziona la tua lingua preferita",
    Location: "Posizione",
    Selectyourlocation: "Seleziona la tua posizione",
    NotificationSetting: "Impostazioni di notifica",
    EmailNotification: "Notifica via email",
    ServiceUpdates: "Aggiornamenti del servizio",
    CompanyNews: "Notizie aziendali",
  },
  AddCredit: {
    //未对应
    Customizeyourplan: "Customize your plan however you need",
    Silver: "Silver",
    Gold: "Gold",
    Enterpris: "Enterpris",
    Credit: "Credit",
    Remaining: "Remaining",
    Points: "points",
    Usermonth: "user/ month",
    Useryear: "user/ year",
    PaidMonthlyRenews: "Paid monthly, no need for auto renews",
    PaidAnnuallyRenews: "Paid annually, no need for auto renews",
    ForFullSupport: "for full support to your needs",
    Each: "each",
    CreditsCharged:
      "Credits charged to your account will never expire as long as your account remains active.",
    PaidMonthly: "Paid monthly",
    PaidAnnually: "Paid annually",
    BuyNow: "Buy now",
    ContactNow: "Contact now",
    SearchCompanies:
      "Search companies and get an instant access to company data that includes:",
    EverythinginSilverPackage: "Everything in Silver package, plus:",
    CreditsCanbeUsed:
      "Credits can be used for more data services including the followings:",
    UnlimitedAdvancedSearch: "Unlimited advanced search",
    ViewCompanyProfile: "View company profile",
    CompanyOwnershipStructure: "Company ownership structure",
    CompanyFamilyTree: "Company family tree",
    Companymanagement: "Company management",
    CompanyContactsinfo: "Company contacts info",
    BusinessActivities: "Business activities",
    IndustryBasics: "Industry basics",
    ImportExportRecords: "Import & export records",
    CompanyPublications: "Company publications",
    CompanyNews: "Company news",
    DownloadOnlineReport: "Download online report",
    ManagementDetails: "Management details",
    ShareholderPenetration: "Shareholder penetration (UBO)",
    Financialinfo: "Financial info",
    FinancialAnalysis: "Financial analysis",
    CreditAssessment: "Credit assessment",
    IndustryAnalysis: "Industry analysis",
    MarketAnalysis: "Market analysis",
    SupplyChaininfo: "Supply Chain info",
    CheckSanctions: "Check sanctions",
    CompanyComparison: "Company comparison",
    DataExport: "Data export",
    MonitoringService: "Monitoring service",
    DiscountForFreshUpdateReports: "Discount for fresh update reports",
    SearchCompany: "Search Company",
    SearchLeads: "Search Leads",
    SearchTrade: "Search Trade",
    SearchPeople: "Search People",
    SearchCountry: "Search Country",
    SearchNews: "Search News",
    SearchSanction: "Search Sanction",
    DataServices: "Data Services",
    APIPlans: "API Plans",
    VolumeDiscounts: "Volume Discounts",
    GroupAccountsWithMultipleUsers: "Group Accounts with multiple users",
    CustomizedPlans: "Customized Plans",
    FreshInvestigatedCreditReportsWorldwide:
      "Fresh investigated credit reports worldwide",
    BusinessMonitoringServices: "Business monitoring services",
    BusinessProcessVerificationServices:
      "Business process verification services",
    VendorComplianceReports: "Vendor compliance reports",
    MarketResearch: "Market research",
    More: "More…",
    Contactus: "Contact us",
    PaymentMethod: "Payment Method",
    CreditCardNumber: "Credit Card Number",
    EnterCardNumber: "Enter Card Number",
    ExpirationDate: "Expiration Date",
    Fullnameoncard: "Full name on card",
    EnterFullname: "Enter Full name",
    EnterProvinceState: "Enter Province / State",
    CVCCode: "CVC Code",
    EnterCVCCode: "Enter CVC Code",
    IncorrectCreditCardNumberformat: "Incorrect Credit Card Number format ",
    IncorrectExpMonthformat: "Incorrect Exp.Month format",
    IncorrectExpYearformat: "Incorrect Exp.Year format",
    IncorrectFullNameformat: "Incorrect Full Name format",
    IncorrectCountryformat: "Incorrect Country format",
    IncorrectProvinceStateformat: "Incorrect Province / State format",
    IncorrectCVCCodeformat: "Incorrect CVC Code format",
    TotalPurchase: "Total Purchase",
    Agree1: "By clicking “Submit”, you agree to the ",
    Agree2: "CSI Services Agreement and Privacy .",
    Submit: "Submit",
    Month: "Month",

    Year: "Anno",
    Country: "Paese",
    ProvinceState: "Provincia/Stato",
    Cancel: "Annulla",
  },
  ReportIssues: {
    Whattypeoferrorsyouarereporting: "Che tipo di errori stai segnalando?",
    Tellusmoreaboutyourproblems: "Descrivici meglio i tuoi problemi.",
    Wouldyouliketoprovideascreenshotorafileregardingyourproblem:
      "Desideri fornire uno screenshot o un file relativo al tuo problema?",
    Fillinyourcontactinformation: "Inserisci i tuoi dati di contatto",
    FirstName: "Nome",
    LastName: "Cognome",
    PhoneNumber: "Numero di telefono",
    Email: "Email",
    Edit: "Modifica",
  },
  //Risk Scan
  RiskScan: {
    RiskScan: "Risk Scan",
    RiskScanInfo:
      " è la piattaforma completa per una gestione completa dei rischi aziendali. Forniamo analisi dettagliate su tutte le principali categorie di rischio per salvaguardare le vostre decisioni aziendali.",
    LegalRisk: "Rischio legale",
    LegalRiskInfo: "verificare la legittimità dell’azienda",
    OrganizationalRisk: "Rischio organizzativo",
    OrganizationalRiskInfo:
      "stabilità gestionale, complessità della struttura aziendale e trasparenza della proprietà.",
    OperationalRisk: "Rischio operativo",
    OperationalRiskInfo:
      "vulnerabilità della catena di fornitura, stato operativo ed esposizione geopolitica.",
    FinancialRisk: "Rischio di performance finanziaria",
    FinancialPerformanceRiskInfo:
      "tendenze di redditività, problemi di liquidità e salute del bilancio.",
    CreditRisk: "Rischio di credito",
    CreditRiskInfo:
      "affidabilità creditizia, cronologia dei pagamenti e probabilità di insolvenza.",
    ComplianceRisk: "Rischio di conformità",
    ComplianceRiskInfo:
      "rispetto delle sanzioni, delle normative AML e delle leggi specifiche del settore",
    SustainabilityRisk: "Rischio di sostenibilità",
    SustainabilityRiskInfo:
      "fattori ESG (ambientali, sociali, di governance) e impatti sulla reputazione.",
    IndustryRisk: "Rischio di settore",
    IndustryRiskInfo:
      "valuta la stabilità e le prospettive dell'intero settore di un'azienda.",
    LetBegin: "Iniziamo",
    AddcompaniesfromSearchResult:
      "Aggiungi aziende dai risultati della ricerca",
    AddcompaniesfromMyDatabase: "Aggiungi aziende dal mio database",
    Addcompaniesbyuploadmyownlist: "Aggiungi aziende caricando il mio elenco",
    Cancel: "Annulla",
    Confirm: "Confermare",
    UploadFiles: "Carica file",
    PleaseuploadyourfileinCVSformat: "Carica il tuo file in formato xlsx",
    Downloadxlsxtemplate: "Scarica il modello xlsx",
    //语序问题未对应
    Xcompanieswereuploadedsucessfuly: "companies were uploaded sucessfuly.",
    Xcompanieswereidentifiedsucessfuly: "companies were identified sucessfuly.",
    Xcompanieswerenotmatched: "companies were not matched.",

    Uploadingfilefailed:
      "Caricamento del file non riuscito. Utilizza il modello e riprova.",
    ALL: "Tutti",
    SearchLeads: "Cerca potenziali clienti",
    LastUpdate: "Ultimo aggiornamento",
    CompanyID: "ID aziendale",
    CompanyType: "Tipo di azienda",
    RegistrationDate: "Data di registrazione",
    RegistrationStatus: "Stato di registrazione",
    Listed: "quotato in borsa",
    LegalStatus: "Stato legale",
    NoofShareholders: "Numero di azionisti",
    ShareholdingLayers: "Livelli degli azionisti",
    NoofCorporateShareholders: "Numero di azionisti aziendali",
    NoofNatualPersonShareholders: "Numero di azionisti persone fisiche",
    RelatedCompanies: "Società collegate",
    OrganizationalStatus: "Stato organizzativo",
    OperatingAddress: "Indirizzo operativo",
    IndustryCode: "Codice dell'industria",
    BusinessActivities: "Attività commerciali",
    NoofEmployees: "Numero di dipendenti",
    Management: "Gestione",
    CurrentOperations: "Operazioni correnti",
    Revenue: "fatturato",
    Assests: "Attività",
    ProfitLoss: "Profitto/Perdita",
    Liquidity: "Liquidità",
    Growth: "crescita",
    Performance: "Performance operativa",
    CreditRating: "Valutazione del credito",
    CreditScore: "Punteggio di credito",
    PausibilityofDefault: "Pausibilità del default (PD)",
    SolvencyIndex: "Indice di solvibilità",
    DebtCollection: "recupero crediti",
    CreditOpinion: "Parere di credito",
    CompanySanction: "di sanzioni aziendali",
    ProductSanction: "Sanzione del prodotto",
    ExportControl: "Controllo delle esportazioni",
    AntiCorruptionAntiBribery: "Anticorruzione e anti-concussione",
    Litigations: "contenziosi",
    NegativeNews: "Notizie negative",
    ESGScore: "Punteggio ESG",
    YearsinBusiness: "Anni di attività",
    Competitiveness: "Competitività",
    WorkingCapital: "Rischio di mercato",
    FinancialStructure: "Indice della catena di fornitura",
    Industrystatus: "Stato del settore",
    IndustryOutlook: "Prospettive del settore",
    NoofCompanies: "Número de empresas",
    IndustryRanking: "Classifica del settore",
    IndustryConcentration: "PIL dell'industria %",
    IndustryCompetitiveness: "Industry Competitiveness", //未对应
    IndustryDevelopment: "Industry Development", //未对应
    CompanyName: "Nome dell'azienda",
    Legal: "Rischio legale",
    Organizational: "Rischio organizzativo",
    Operational: "Rischio operativo",
    Financial: "Rischio finanziario",
    Credit: "Rischio di credito",
    Compliance: "Rischi di conformità",
    Sustainability: "Sostenibilità",
    Industry: "Rischio industriale",
    Download: "Scarica",
    StartDate: "Data di inizio",
    EndDate: "Data di fine",
    Entercompanyname: "Inserisci il nome dell'azienda",
    Tryagain: "Riprova",
    //未对应
    Uploadyourlistofcompanies:
      "Upload your list of companies, and Risk Scan will provide you with instant data updates for each entity. With comprehensive risk assessments across seven risk categories, Risk Scan transforms your risk management from reactive to a proactive strategic advantage.",
    Choose: "Choose",
    Upload: "Upload",
    Uploading: "Uploading",
    Uploadwithamaximumfilesizeof1M:
      "(Upload up to 100 pieces of data at a time, with a maximum file size of 1M)",
    Tryagain: "Try again",
    Theuploadedonlyxlsx: "The uploaded file can only be in xls/xlsx format",
    RiskScanning: "Risk Scanning",
    Youhaveselectedatotalof: "You have selected a total of",
    Tostartriskscanning: "companies, click “confirm” to start risk scanning",
    Datascanningisinprogress: "Data scanning is in progress ...",
    ClearAll: "Clear All",
    SelectUpdateDate: "Select Last Update",
    UpdateStatus: "Update Status",
    Updated: "Updated",
    Notupdated: "Not updated",
    Updating: "Updating",
    SelectRiskValue: "Select Risk Value",
    ReSelectData: "Re Select Data",
    HistoricalData: "Historical Data",
    DiagnosticReport: "Diagnostic Report",
    Good: "Good",
    General: "General",
    Differ: "Differ",
    NotEvaluated: "Not Evaluated",
    ScanTime: "Scan Time",
  },
  //Data Management
  DataManagement: {
    DataManagement: "gestione dei dati",
    AllCompanies: "Tutte le aziende",
    CompaniesViewed: "Aziende visualizzate",
    CompaniesCollected: "Aziende raccolte",
    CompaniesUploaded: "Aziende caricate",
    MyPortfolio: "Il mio portafoglio",
    Date: "Data",
    CompanyName: "Nome dell'azienda",
    Country: "Paese",
    CompanyType: "Tipo di azienda",
    CompanyStatus: "Stato dell'azienda",
    DQI: "DQI",
    Download: "Scaricamento",
    Addcompanies: "Aggiungi aziende",
    Filter: "Filter",
    Selectcountry: "Seleziona il paese",
    Selectindustry: "Seleziona il settore",
    Selectcompanytype: "Seleziona il tipo di azienda",
    Selectcompanysize: "Seleziona la dimensione dell'azienda",
    Selectcompanystatus: "Seleziona lo stato dell'azienda",
    Selectlistedcompanies: "Seleziona le società quotate",
    Selectcompanyyearsinbusiness: "Seleziona gli anni di attività dell'azienda",
    Industry: "Industria",
    CompanySize: "Dimensioni dell'azienda",
    Listed: "Quotate",
    CompanyAge: "Età dell'azienda",
    SelectYear: "Seleziona anno",
    SelectQuarter: "Seleziona trimestre",
    SelectMonth: "Seleziona mese",
    Reset: "Reset",
    Search: "Ricerca",
    MyDatabase: "Il mio database",
    Locations: "Sedi",
    YearsinBusiness: "Anni di attività",
    CompanyDQI: "DQI",
    RiskScan: "Scansione del rischio",
    CreditAssessment: "Valutazione del credito",
    Uptodate: "Aggiornato",
    Average: "Media",
    Insufficient: "Insufficient",
    Good: "Bene",
    Caution: "Attenzione",
    Unknown: "Sconosciuta",
    CompanyTag: "Etichetta aziendale",
    Remove: "Rimuovere",
    Uploaded: "Caricato",
    Identified: "Identificato",
    Notmatched: "Non abbinato",
    Identifythecompanywithmanualcheck:
      "Identificare l'azienda con controllo manuale",
    Identifyacompanymanually: "Identificare manualmente un'azienda",
    Pleaseprovideanyrelevantinformation:
      "Fornisci tutte le informazioni rilevanti che potrebbero migliorare i risultati della ricerca. Il nostro analista dati ti metterà in contatto con l'azienda più adatta.",
    RegistrationID: "ID aziendale",
    StateProvince: "Stato/Provincia",
    Address: "Indirizzo",
    Otherinformation: "Altre informazioni",
    Submit: "Invia",
    Cancel: "Compito",
    Confirm: "Confermare",
    PortolioName: "Nome del portafoglio",
    User: "Utente",
    Task: "Task",
    NoofCompanies: "Numero di aziende",
    Entercompanyname: "Inserisci il nome dell'azienda",
    SaveYourPortfolio: "Salva il tuo portafoglio",
    PortfolioName: "Nome del portafoglio",
    Notes: "Note",

    //未对应
    UploadCompanies: "Upload Companies",
    Match: "Match",
    Delete: "Delete",
    Edit: "Edit",
    EnterRegistrationID: "Enter Registration ID",
    EnterAddress: "Enter Address",
    EnterInformation: "Enter Information",
    EnterPortfolioName: "Enter Portfolio Name",
    EnterUserName: "Enter User",
    SelectTaskName: "Select Task",
    EnterNotes: "Enter Notes",
    OnlineMatching: "Online Matching",
    StartingMonth: "Starting Month",
    EndMonth: "End Month",
  },
  ...itLocale,
};

export default it;
